import {Injector, Component , Input, OnInit, ViewEncapsulation} from '@angular/core';
import { BaseComponent } from '../../base.component';

@Component ({
selector: 'call-me-now',
template:`
<div class="container" [ngClass]="{ 'hide-btn': !showButton }">
<input type="text"
       name="contact-phone"
       placeholder="Enter Phone Number"
       autocomplete="off">
<div class="btn">Call Me Now</div>
</div>
`,
styleUrls: ['./call-me-now.component.scss']
})

export class CallMeNowComponent extends BaseComponent implements OnInit {
    showButton: boolean
 constructor(injector : Injector){
     super(injector);
 }

 ngOnInit() {

 }
}